import * as types from "./types";
/*type: success, error, warning, general*/
export const pushNotification = (message, type) => ({
  type: types.PUSH_NOTIFICATION,
  notification: { message, type }
});

export const removeNotification = notification => ({
  type: types.REMOVE_NOTIFICATION,
  notification: notification
});
